import { Heading, Text, VStack } from "@chakra-ui/react";

export type PageTitleProps = {
  title: string;
  description: string;
};

export function AgencySettingsPageTitle({ title, description }: PageTitleProps) {
  return (
    <VStack gap={2} alignItems={"flex-start"}>
      <Heading size={{ base: "2xl", md: "lg" }} fontWeight={700}>
        {title}
      </Heading>
      <Text>{description}</Text>
    </VStack>
  );
}
